import List from 'containers/Applications/List';
import Edit from 'containers/Applications/Edit';
import Create from 'containers/Applications/Create';
import Show from 'containers/Applications/Show';

export default { List, Edit, Create, Show };
